module.exports = {"id":"191910","name":"Kim Shin Wook","rating":"74","photo":"./data/images/photos/3/191910.png","club":{"name":"Jeonbuk Hyundai","logo":"./data/images/clubs/JeonbukHyundai.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KimShinWook0.json
// module id = 2384
// module chunks = 0